import React, { useState, useEffect } from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import Demo from '../Pages/Demo/Demo'
import VisitTracker from '../Components/VisitTracker/VisitTracker'

export default function IndexLayout() {




    return (
        <div className='section-bg-color'>
            <VisitTracker />
            <Nabvar />
            <div className='espaciobg'>

            </div>
            <Demo />
        </div>
    );
}
